// "Beweglichkeitsalter" (Flexibility Age) — spielerischer Fitness-Wert im
// eGym-Stil. Composite aus den Ampel-Bändern aller Bewegungen, verschoben
// gegen einen groben Alters-Anker. KEINE klinische Norm, KEINE medizinische
// Aussage — siehe gait/docs/FLEX_WELLNESS_ABGRENZUNG.md.

import type { FlexAgeResult, FlexFinding } from "./types";

export const FLEX_AGE_MODEL_VERSION = "flex-age-seed-1";

const BAND_POINTS: Record<FlexFinding["band"], number> = {
  EINGESCHRAENKT: 0,
  OK: 1,
  GUT: 2,
};

/** Generic anchor age used when no birth year is on file. */
const REFERENCE_AGE = 40;
/** A perfect/worst composite shifts the displayed age by at most this many years. */
const MAX_SPREAD_YEARS = 20;

export function computeFlexAge(
  findings: FlexFinding[],
  chronoAge: number | null,
  previousFlexAge?: number | null,
): FlexAgeResult {
  if (!findings.length) {
    return {
      flexAge: chronoAge ?? REFERENCE_AGE,
      chronoAge,
      compositeScore: 50,
      comparedToPrevious: null,
    };
  }

  const points = findings.reduce((acc, f) => acc + BAND_POINTS[f.band], 0);
  const maxPoints = findings.length * 2;
  const compositeScore = Math.round((points / maxPoints) * 100); // 0..100

  const anchor = chronoAge ?? REFERENCE_AGE;
  // Composite 100 ("durchgängig gut") -> jüngeres Beweglichkeitsalter;
  // Composite 0 ("durchgängig eingeschränkt") -> älteres Beweglichkeitsalter.
  const offsetYears = ((50 - compositeScore) / 50) * MAX_SPREAD_YEARS;
  const flexAge = Math.round(Math.min(99, Math.max(5, anchor + offsetYears)));

  const comparedToPrevious =
    previousFlexAge != null ? flexAge - previousFlexAge : null;

  return { flexAge, chronoAge, compositeScore, comparedToPrevious };
}
